import { useEffect, useState } from 'react';
import { useI18n } from '@namespace/i18n';
import { socketSend } from '@namespace/socket';

const useSetUpUserName = () => {
  const { t } = useI18n();
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [credentials, setCredentials] = useState(null);

  useEffect(() => {
    setError(null);

    if (credentials !== null) {
      const { login, password, newLogin } = credentials;

      (async () => {
        try {
          const response = await socketSend({
            cmd: 'accounting/change_login_equaled_email',
            cid: 1,
            data: {
              login,
              password,
              new_login: newLogin
            }
          });

          if (response?.ok) {
            setSuccess(true);
            setError('');
          } else {
            setSuccess(false);
            setError(t('accounting_error_1423'));
          }
        } catch (e) {
          setSuccess(false);
          setError(e.message);
        }
      })();
    }
  }, [credentials]);

  return {
    setCredentials,
    credentials,
    success,
    error
  };
};

export default useSetUpUserName;
